<a class="icon-soc" :href="link" target="_blank" v-bind:style="styles"><InlineSvg class="filled" :src="require(`@/assets/images/${icon}.svg`)"></InlineSvg></a>